import { createRouter,createWebHistory} from 'vue-router'
import LoginPage from '@/pages/LoginPage.vue'
import HomePage from '@/pages/HomePage.vue'
import InquirePage from '@/pages/son_pages/purchase/InquiryPage.vue'
import PurchaseInputWarehousePage from '@/pages/son_pages/purchase/PurchaseInputWarehousePage.vue'
import PurchaseOrderPage from '@/pages/son_pages/purchase/PurchaseOrderPage.vue'
import PurchaseReturnPage from '@/pages/son_pages/purchase/PurchaseReturnPage.vue'
import PurchaseReplacementPage from '@/pages/son_pages/purchase/PurchaseReplacementPage.vue'
import PurchaseStatisticsPage from '@/pages/son_pages/purchase/PurchaseStatisticsPage.vue'
import PersonCenterPage from '@/pages/son_pages/person/PersonCenter.vue'
import SellQuotedPricePage from '@/pages/son_pages/sell_pages/SellQuotedPricePage.vue'
import SellOrderPage from '@/pages/son_pages/sell_pages/SellOrderPage.vue'
import SellOutputWarehousePage from '@/pages/son_pages/sell_pages/SellOutputWarehousePage.vue'
import SellReturnPage from '@/pages/son_pages/sell_pages/SellReturnPage.vue'
import SellReplacePage from '@/pages/son_pages/sell_pages/SellReplacePage.vue'

import StaffManagerPage from '@/pages/son_pages/staff/StaffManagerPage.vue'
import WarehouseMangePage from '@/pages/son_pages/warehouse_pages/WarehouseMangePage.vue'
import WarehouseCheckPage from '@/pages/son_pages/warehouse_pages/WarehouseCheckPage.vue'
import WarehouseStorgePage from '@/pages/son_pages/warehouse_pages/WarehouseStorgePage.vue'
import WarehouseCheckCreatePage from '@/pages/son_pages/warehouse_pages/WarehouseCheckCreatePage.vue'

import IndexPage from '@/pages/son_pages/IndexPage.vue'
import SettingPage from '@/pages/son_pages/setting/SettingPage.vue'
import CooperativePartnerPage from '@/pages/son_pages/cooperative_partner/CooperativePartnerPage.vue'
import OtherInputWarehousePage from '@/pages/son_pages/warehouse_pages/OtherInputWarehousePage.vue'
import OtherOutputWarehousePage from '@/pages/son_pages/warehouse_pages/OtherOutputWarehousePage.vue'

import PrintPage from '@/pages/son_pages/print/PrintPage.vue'

import TransformWarehousePage from '@/pages/son_pages/warehouse_pages/TransformWarehousePage.vue'
import AiChatPage from '@/pages/son_pages/ai/AiChatPage.vue'


const routes = [
	{
		path: '/',
		name: 'login_page',
		component: LoginPage
	},
	{
		path: '/home',
		name: 'home_page',
		component: HomePage,
		children: [
			{
				path: '/home/inquire',
				name: 'inquire_page',
				component: InquirePage
			},
			{
				path: '/home/index',
				name: 'index_page',
				component: IndexPage
			},
			{
				path: '/home/setting',
				name: 'setting_page',
				component: SettingPage
			},
			{
				path: '/home/purchase_input_warehouse',
				name: 'purchase_input_warehouse',
				component: PurchaseInputWarehousePage
			},
			{
				path: '/home/purchase_order',
				name: 'purchase_order',
				component: PurchaseOrderPage
			},
			{
				path: '/home/purchase_return',
				name: "purchase_return",
				component: PurchaseReturnPage
			},
			{
				path: '/home/purchase_replacement',
				name: "purchase_replacement",
				component: PurchaseReplacementPage
			},
			{
				path: '/home/purchase_statistics',
				name: "purchase_statistics",
				component: PurchaseStatisticsPage
			},
			{
				path: '/home/person_center',
				name: "person_center",
				component: PersonCenterPage
			},
			{
				path: '/home/sell_quoted_price',
				name: "sell_quoted_price",
				component: SellQuotedPricePage
			},
			{
				path: '/home/sell_order',
				name: "sell_order",
				component: SellOrderPage
			},
			{
				path: '/home/sell_output_warehouse',
				name: "sell_output_warehouse",
				component: SellOutputWarehousePage
			},
			{
				path: '/home/sell_return',
				name: "sell_return",
				component: SellReturnPage
			},
			{
				path: '/home/sell_replace',
				name: "sell_replace",
				component: SellReplacePage
			},
			{
				path: '/home/staff_manager',
				name: "staff_manager",
				component: StaffManagerPage
			},
			{
				path: '/home/warehouse_mange',
				name: "warehouse_mange",
				component: WarehouseMangePage
			},
			{
				path: '/home/warehouse_check',
				name: "warehouse_check",
				component: WarehouseCheckPage
			},
			{
				path: '/home/warehouse_storge',
				name: "warehouse_storge",
				component: WarehouseStorgePage
			},
			{
				path: '/home/print',
				name: 'print',
				component: PrintPage
			},
			{
				path: '/home/warehouse_check_create',
				name: 'warehouse_check_create',
				component: WarehouseCheckCreatePage
			},
			{
				path: '/home/cooperative_partner',
				name: 'cooperative_partner',
				component: CooperativePartnerPage
			},
			{
				path: '/home/other_input',
				name: 'other_input',
				component: OtherInputWarehousePage
			},
			{
				path: '/home/other_output',
				name: 'other_output',
				component: OtherOutputWarehousePage
			},
			{
				path: '/home/transform_warehouse',
				name: 'transform_warehouse',
				component: TransformWarehousePage
			},
			{
				path: '/home/ai_chat',
				name: 'ai_chat',
				component: AiChatPage
			}
		]
	}
]

const router = createRouter({
	history: createWebHistory(),
	routes
})

router.beforeEach((to, from, next) => {
	if (to.name === 'login_page') {
		next()
	} else {
		if (sessionStorage.getItem('user_id')) {
			next()
		} else {
			next({ name: 'login_page' })
		}
	}
})

export default router